import gsap from 'gsap';



function productsblock() {
    const PRboxes = document.querySelectorAll('[data-target="pr_box"]');
    const pr_title = document.querySelector('[data-target="pr_title"]');
    
    const pr_box_wrap = document.querySelector('[data-target="pr_box_wrap"]');
    
    if (!PRboxes) { return; }

    // gsap.from(PRboxes, {
    //     autoAlpha: 0,
    //     y:20,
    //     duration: 1.8,
    //     stagger:0.2,
    //     scrollTrigger: {
    //         trigger: pr_box_wrap,
    //         start:'top 70%'
        
    //     },
    // });
    // gsap.from(pr_title, {
    //     autoAlpha: 0,
    //     duration: 1.8,
    //     scrollTrigger: {
    //         trigger: pr_box_wrap,
    //         start:'top 70%'
        
    //     },
    // });
    
    

    PRboxes.forEach(function(PRbox) {
       
            // const iButton = PRbox.querySelector('[data-target="i_button"]');
            // const gOpacity = PRbox.querySelector('[data-target="g_opacity"]');

            // const h3 = PRbox.querySelector('h3');
            // const tooltip = PRbox.querySelector('[data-target="tooltip"]');
            // const taxonomy_txt = PRbox.querySelector('[data-target="taxonomy_txt"]');
            
            // let tl, tlback;

            // iButton.addEventListener('mouseover', function() {
            //     if (tlback && tlback.isActive()) {
            //         tlback.kill();
            //     }

            //     tl = gsap.timeline();
            //     tl.to([h3, taxonomy_txt], {autoAlpha: 0, duration: 0.5}, "start")
            //       .to(gOpacity, {fillOpacity: 1, duration: 0.5}, "start")
            //       .to(tooltip, {autoAlpha: 1, duration: 0.3});
            // });

            // iButton.addEventListener('mouseout', function() {
            //     if (tl && tl.isActive()) {
            //         tl.kill();
            //     }

            //     tlback = gsap.timeline(); 
            //     tlback.to(tooltip, {autoAlpha: 0, duration: 0.3}, "start")
            //           .to(gOpacity, {fillOpacity: 0.2, duration: 0.5}, "start")
            //           .to([h3, taxonomy_txt], {autoAlpha: 1, duration: 0.5});
            // });
        
    });
    
    
}


export { productsblock }; 